import type { HTTPResponse } from '@carboncopyco/types';

export const getContentSha256Header = (response: HTTPResponse) =>
  response.headers['x-ds-txnf-id']?.[0];
